import { ChangeDetectionStrategy, Component, input, InputSignal, model, ModelSignal } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { mobileSelectionAnimation } from '../animation';

@Component({
  selector: 'ui-mobile-selection-item',
  imports: [MatCheckbox],
  templateUrl: './mobile-selection-item.component.html',
  styleUrl: './mobile-selection-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    mobileSelectionAnimation,
  ],
})
export class MobileSelectionItemComponent {
  public selected: ModelSignal<boolean> = model.required();
  public selectionVisible: InputSignal<boolean> = input.required();
}
